
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AdvanceConfig": [
      "EscrowAdvanceConfig",
      "StandardAdvanceConfig"
    ],
    "Attribution": [
      "DelinquentInterestAttribution",
      "DrawInterestAttribution",
      "PartialPayoffInterestAttribution",
      "StandardInterestAttribution"
    ],
    "AuthorizedContact": [
      "BuilderAuthorizedContact",
      "ThirdPartyAuthorizedContact"
    ],
    "AutopaySettings": [
      "DwollaAutopaySettings",
      "NachaAutopaySettings",
      "RepayAutopaySettings",
      "UsioAutopaySettings"
    ],
    "Charge": [
      "Advance",
      "Fee"
    ],
    "Document": [
      "DefermentWorkoutPlanDocument",
      "DelinquentInterestAppliedDocument",
      "EscrowAnalysisDocument",
      "Form1098Document",
      "GeneralDocument",
      "PayoffDocument",
      "PrincipalModificationAppliedDocument",
      "PrincipalModificationCancelledDocument",
      "UploadDocument",
      "VerificationOfMortgageDocument"
    ],
    "EscrowDue": [
      "InsuranceEscrowDue",
      "MortgageInsuranceEscrowDue",
      "TaxEscrowDue"
    ],
    "EscrowSetting": [
      "InsuranceEscrowSetting",
      "MortgageInsuranceEscrowSetting",
      "TaxEscrowSetting"
    ],
    "LoanLateFee": [
      "LoanLateFeeFixed",
      "LoanLateFeePercent"
    ],
    "LoanPrincipalLateFee": [
      "LoanPrincipalLateFeeDisabled",
      "LoanPrincipalLateFeeFixed",
      "LoanPrincipalLateFeePercent"
    ],
    "LoanTerminationFee": [
      "LoanTerminationFeeDisabled",
      "LoanTerminationFeeFixed",
      "LoanTerminationFeePercent"
    ],
    "Modification": [
      "FlexModification",
      "PrincipalModification"
    ],
    "PaidOffRecord": [
      "TrackedPaidOffRecord",
      "UntrackedPaidOffRecord"
    ],
    "Payer": [
      "AuthorizedContactPayer",
      "BorrowerPayer",
      "EntityPayer",
      "ThirdPartyPayer"
    ],
    "PaymentToPaymentDue": [
      "AdvanceBreakdown",
      "BalanceReallocationBreakdown",
      "FeeBreakdown",
      "PayoffBreakdown",
      "PrincipalPrepaymentBreakdown",
      "StatementBreakdown",
      "SuspenseBreakdown",
      "ThirdPartyBreakdown"
    ],
    "WorkoutPlan": [
      "DefermentWorkoutPlan",
      "FlexModificationWorkoutPlan",
      "ForbearanceWorkoutPlan",
      "PaymentDeferralWorkoutPlan",
      "RepaymentWorkoutPlan"
    ]
  }
};
      export default result;
    